module.exports = __webpack_public_path__ + "static/media/buyers_list_banner.ff5c5bc6.jpg";